import { IAPIRoutes } from "../../../../config";

export type IMedicationReconciliationRepository = ReturnType<
  typeof MedicationReconciliationRepositoryFactory
>;

export const MedicationReconciliationRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const uploadDischargePdfAPI: IUploadDischargePdfAPI = async (payload) => {
    const formData = new FormData();
    formData.append("patient_id", payload.patient_id.toString());
    formData.append("file", payload.file);

    return POST(
      APIRoutes.apiUploadDischargePdf.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        // Don't set Content-Type for FormData, let the browser set it with boundary
      }
    );
  };

  const getDischargePdfUploadsAPI: IGetDischargePdfUploadsAPI = async (
    payload
  ) => {
    const queryParams: Record<string, any> = {
      patient_id: payload.patient_id,
    };
    if (payload.limit !== undefined) {
      queryParams.limit = payload.limit;
    }
    return GET(
      APIRoutes.apiGetDischargePdfUploads.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      queryParams,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  return {
    uploadDischargePdfAPI,
    getDischargePdfUploadsAPI,
  };
};
